module.exports = __webpack_public_path__ + "static/media/payment-icon.0dc2e2e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/bottom-home-search/payment-icon.png
// module id = 2252
// module chunks = 0